import {
    Box,
    Flex,
    Select,
    SkeletonText,
    Text
} from '@chakra-ui/react';
import { useEffect, useState, useRef } from 'react';
import { useSelector } from 'react-redux';
import { useGetWhatsAppBusinessAccountsQuery } from 'store/campaigns/adsetFormApi';
import { truncateString } from 'utils/functions';

function WhatsAppSelector({ adsAccount, onSelectedNumber = {}, selectedWhatsAppNumber, context = '' }) {

    const { adsAccountId, adsAccountName, businessId } = adsAccount || {};
    const [selectedNumber, setselectedNumber] = useState(selectedWhatsAppNumber || '');
    const userInfo = useSelector((state) => state.auth?.userInfo);

    const { data: whatsAppData, error: whatsAppError, isLoading: isLoadingWhatsApp } = useGetWhatsAppBusinessAccountsQuery({businessId}, {
        skip: !businessId,
    });
    
    const hasSetDefault = useRef(false); 

    useEffect(() => {
      if (
        !selectedWhatsAppNumber &&
        whatsAppData?.data?.length > 0 &&
        !hasSetDefault.current
      ) {
        const firstPhone =
          whatsAppData.data[0]?.phone_numbers?.data?.[0]?.display_phone_number;
    
        if (firstPhone) {
          setselectedNumber(firstPhone);
          const rawNumber = firstPhone.replace(/\D/g, '');
          onSelectedNumber?.(rawNumber, adsAccountId);

          hasSetDefault.current = true; 
        }
      }
    }, [whatsAppData, selectedWhatsAppNumber, adsAccountId]);
      
    const handleWhatsAppNumberChange = (event) => {
        const number = event.target.value;
        setselectedNumber(number);
        const rawNumber = number.replace(/\D/g, '');
        onSelectedNumber?.(rawNumber, adsAccountId);
    };
    

    return (
        <Box>
            <Flex gap={2} direction={'column'}>
                <Flex>
                    {isLoadingWhatsApp ? (
                         <Flex width={'100%'}>
                            <SkeletonText width="80%" noOfLines={2}  skeletonHeight={2}/>
                        </Flex>
                    ) : (
                        <Flex w={'100%'}>
                            <Flex alignItems={'center'} gap={2} flex={0.5}>
                                <Text fontWeight={'bold'} fontSize={'12px'}>{truncateString(adsAccountName, 40)}</Text>
                                <Text fontSize={'12px'}>({adsAccountId})</Text>
                            </Flex>
                            <Flex flex={0.5}>
                                <Select
                                    value={selectedNumber}
                                    onChange={handleWhatsAppNumberChange}
                                    borderRadius="md"
                                    size="sm"
                                    isDisabled={userInfo?.role !== 'client' || context === 'update'}
                                >
                                    {whatsAppData?.data?.flatMap((account) =>
                                        account.phone_numbers?.data?.map((phone) => (
                                        <option key={phone.id} value={phone.display_phone_number}>
                                            {phone.display_phone_number}
                                        </option>
                                        ))
                                    )}
                                </Select>
                            </Flex>
                        </Flex>
                    )}
                </Flex>
            </Flex>
        </Box>
    )
}

export default WhatsAppSelector